export default "https://cdn-static.gokick.com/assets/d6a1d1f7abc93216fd07fb40adb7adf28904b072/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";